import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import styled from 'styled-components';

import { MenuItem } from '@mui/material';

import { PickerProps } from 'components/Grid/operators/types';

import { StyledSelect } from 'components/Input/styles';

import { createFilterRegex } from 'utils/regex';
import { colors } from 'theme/colors';
import { UserRoleNames } from 'core/constants';

export const StyledMenuItem = styled(MenuItem)`
  color: ${colors.legacy.grey[200]};
  font-size: 1.3rem;
  line-height: 2rem;
  p {
    margin: 0;
  }
`;

const UserRoles: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <StyledSelect
    {...props}
    value={item.value && (item.value as string).startsWith('-') ? (item.value as string).slice(1) : item.value}
    fullWidth
    onChange={(newValue) => applyValue({ ...item, value: newValue.target.value })}
  >
    <StyledMenuItem key="user" value="user">
      <p>User</p>
    </StyledMenuItem>
    <StyledMenuItem key="manager" value="manager">
      <p>Manager</p>
    </StyledMenuItem>
    <StyledMenuItem key="account_manager" value="account_owner">
      <p>Account Owner</p>
    </StyledMenuItem>
  </StyledSelect>
);

export default [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }
      const filterRegex = createFilterRegex(filterItem.value);
      return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
    },
    InputComponent: UserRoles,
    InputComponentProps: { value: null },
    getValueAsString: (value: string) => UserRoleNames[value],
  },
  {
    label: 'is not',
    value: 'is not',
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }
      const filterRegex = createFilterRegex(filterItem.value);
      return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
    },
    InputComponent: UserRoles,
    InputComponentProps: { value: null },
    getValueAsString: (value: string) => UserRoleNames[value.slice(1)],
  },
] as unknown as GridFilterOperator[];
